import * as a from 'api'

export const ENTITY_FLAGS: a.EntityFlags = {
    is_alive: false,
}

export const COUNT: a.Count = {
    alive: -1,
    max_page: -1,
    size: -1,
    total: -1,
}

export const USER_INFO: a.UserInfo = {
    gene: null,
    name: '',
    sessions: [],
    username: '',
    created_at: 0,
    entity_flags: ENTITY_FLAGS,
    session_index: 0,
}

// export const SHAH_BUCKLE: a.ShahBuckle = {
//     belt_count: 0,
//     entity_flags: ENTITY_FLAGS,
//     growth: 0,
//     head: null,
//     gene: null,
//     tail: null,
// }

export const WHEAT_INFO: a.Wheat = {
    priority: 0,
    entity_flags: ENTITY_FLAGS,
    flags: 0,
    pending: 0,
    growth: 0,
    gene: null,
    buckle: null,
    next: null,
    past: null,
    kernels: 0,
    updated: 0,
    tx: 0,
    ty: 0,
}

export const LOCATION: a.Location = {
    latitude: 0,
    longitude: 0,
}

export const WHEAT_KERNEL_INFO: a.WheatKernel = {
    wheat: null,
    wheat_priority: 0,
    entity_flags: ENTITY_FLAGS,
    basket: 'good',
    created_at: 0,
    location: LOCATION,
    growth: 0,
    gene: null,
    name: '',
    title: '',
    id: '',
    pending_at: 0,
    updated_at: 0,
    wheat_category: 'unknown',
    buckle: null,
    past: null,
    next: null,
}

export const FARMER_INFO: a.Farmer = {
    farmed_at: 0,
    token: '',
    growth: 0,
    wheat_kernels: 0,
    wheats: 0,
    entity_flags: ENTITY_FLAGS,
    flags: { banned: false },
    wheat_ards: 0,
    created_at: 0,
    name: '',
    gene: null,
}
